import type { TableSemanticSchema } from './types';

export const KanbanSchema: TableSemanticSchema = {
  id: 'kanban',
  name: 'Kanban Board',
  description:
    'Work-in-progress board with optional WIP limits, cycle-time tracking, and block reason. Column ids are the default workflow — epics override via custom schemas.',
  cells: [
    { id: 'backlog', label: 'Backlog', row: 0, col: 0 },
    { id: 'todo', label: 'To Do', row: 0, col: 1 },
    { id: 'in_progress', label: 'In Progress', row: 0, col: 2 },
    { id: 'review', label: 'Review', row: 0, col: 3 },
    { id: 'done', label: 'Done', row: 0, col: 4 },
  ],
  itemFields: [
    { key: 'status', label: 'Status', kind: 'enum', required: true,
      options: [
        { value: 'backlog', label: 'Backlog' },
        { value: 'todo', label: 'To Do' },
        { value: 'in_progress', label: 'In Progress' },
        { value: 'review', label: 'Review' },
        { value: 'done', label: 'Done' },
      ] },
    { key: 'priority', label: 'Priority', kind: 'enum',
      options: [
        { value: 'urgent', label: 'Urgent' },
        { value: 'high', label: 'High' },
        { value: 'medium', label: 'Medium' },
        { value: 'low', label: 'Low' },
      ] },
    { key: 'assignee', label: 'Assignee', kind: 'string' },
    { key: 'estimate', label: 'Estimate', kind: 'number', description: 'Story points or hours.' },
    { key: 'dueDate', label: 'Due Date', kind: 'date' },
    { key: 'labels', label: 'Labels', kind: 'id-list' },
    { key: 'blockedBy', label: 'Blocked By', kind: 'id-list' },
    { key: 'cycleTime', label: 'Cycle Time (days)', kind: 'number' },
  ],
  renderingHints: {
    layout: 'grid',
    wipLimits: true,
  },
};
